import { FixaSkeleton } from "@coworker/apprestructured/src/shared/wrappers/FixaSkeleton/FixaSkeleton";

function LoadingCardFragment() {
  return <FixaSkeleton width="100%" height="21px" />;
}

export default LoadingCardFragment;
